// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.husEKthKYJAc_0Jy {
  max-width: 1310px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.husEKthKYJAc_0Jy h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.Kq5YxlXICEqkJ9uq {
  margin: 25px 0 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.m7caBGPY3vcHiQrw {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.D83hEwycbYxKx2Uo {
  color: #000000;
  background-color: transparent;
  border: none;
  flex-shrink: 0;
}

.D83hEwycbYxKx2Uo i {
  font-size: 16px;
  background-color: #f2e1bc;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.husEKthKYJAc_0Jy .p-datatable-table {
  border-radius: 16px;
  overflow: hidden;
}

.husEKthKYJAc_0Jy .p-datatable-thead th {
  background-color: #f2e1bc;
  border: 1px solid #f3f5f7;
  padding: 20px 24px;
}

.husEKthKYJAc_0Jy .p-datatable-thead th:first-child > div {
  display: flex;
  justify-content: flex-start;
}

.husEKthKYJAc_0Jy .p-datatable-thead th > div {
  display: flex;
  justify-content: start;
  color: #303030;
  font-size: 18px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
  padding: 8px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr td:first-child {
  text-align: left;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr td > div {
  margin-left: 0;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr .jrHaAwhIsuyHXUpT {
  display: flex;
  justify-content: center;
  align-items: center;
}

.h7jj0RHK00zGd2f8 {
  background-size: cover;
  height: 50px;
  width: 71px;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
}

.h7jj0RHK00zGd2f8 i {
  display: none;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .h7jj0RHK00zGd2f8 i {
  display: block;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .h7jj0RHK00zGd2f8 div {
  width: 100%;
  height: 100%;
  background-color: #2e2e2e55;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody td:hover .Ehpap2ajkkUChVNB {
  background-color: #e1e7ed;
}

.qUKhoyUZBFUto1eO {
  flex-shrink: 0;
  padding: 9px 8px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody td:hover .Ehpap2ajkkUChVNB {
  background-color: #e1e7ed;
}

.Ehpap2ajkkUChVNB {
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding-inline: 16px;
  min-height: 69px;
  font-size: 18px;
}

.pvPx2wdLwJihRKwp {
  display: flex;
  gap: 8px;
}

.ppuMNdpCR9kgPbhS span::before {
  color: #4d87be;
  font-size: 22px;
}

.pU12Ei58k8UIbHOx span::before {
  color: #56be4d;
  font-size: 20px;
}

.UnbL6VAQMG85HNqO span::before {
  color: #dd0000;
  font-size: 20px;
}

.dwmsJzJNZKY7UbfL span::before,
.p4U8TKIo4oMDrfwL span::before {
  color: #4d87be;
  font-size: 20px;
}

.p4U8TKIo4oMDrfwL:hover span::before {
  color: #20336c !important;
}

.pU12Ei58k8UIbHOx,
.dwmsJzJNZKY7UbfL,
.UnbL6VAQMG85HNqO,
.p4U8TKIo4oMDrfwL {
  width: 70px;
  height: 67px;
}

.husEKthKYJAc_0Jy .pU12Ei58k8UIbHOx:hover {
  background-color: #c5f3c1;
}

.husEKthKYJAc_0Jy .dwmsJzJNZKY7UbfL:hover {
  background-color: #e1e7ed;
}

.husEKthKYJAc_0Jy .UnbL6VAQMG85HNqO:hover {
  background-color: #ffcaca;
}

.pU12Ei58k8UIbHOx span::before {
  color: #56be4d;
  font-size: 20px;
}

.UnbL6VAQMG85HNqO span::before {
  color: #dd0000;
  font-size: 20px;
}

.husEKthKYJAc_0Jy .pU12Ei58k8UIbHOx span::before {
  color: #185625;
}

.husEKthKYJAc_0Jy .dwmsJzJNZKY7UbfL:hover span::before {
  color: #20336c;
}

.pU12Ei58k8UIbHOx:hover span::before {
  color: #185625;
}

.dwmsJzJNZKY7UbfL:hover span::before {
  color: #20336c;
}

.dwmsJzJNZKY7UbfL span::before {
  color: #4d87be;
  font-size: 20px;
}

.K2IrzQkh5MegWWVR {
  width: 114px;
  height: 67px;
}

.Mp5jVP1l42k1TjbK {
  width: 100%;
}

.Mp5jVP1l42k1TjbK > span {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 14px 0px;
  font-size: 18px;
  font-weight: 600;
}

.Mp5jVP1l42k1TjbK > span:hover {
  background-color: #20336c;
}

.Mp5jVP1l42k1TjbK > span > span {
  width: fit-content;
  flex-grow: 0;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .K2IrzQkh5MegWWVR {
  background-color: #e1e7ed;
}

.pD5ouHisBTEs8Klr {
  display: inline-block;
}

.cUy_s0zrNQ88HWUr {
  background-color: #f2efea;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.Tc5IpmuqkUKBNjjR {
  width: 250px;
  height: 250px;
  border-radius: 54px;
  overflow: hidden;
}

.Tc5IpmuqkUKBNjjR .yXv_pSMTUsY5eoZ7 {
  height: 173px;
  background-color: gray;
  background-size: cover;
}

.Tc5IpmuqkUKBNjjR .oUsnoH13QfsFE4Ya {
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-family: "Roboto";
  background-color: #ffffff;
}

.a2yrN1pM9CUr13gZ {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.GdWTwEzlr4Du68Uy {
  border-radius: 16px 0 0 16px !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.GdLxUVfCvgNLiSVL {
  border-radius: 0 16px 16px 0 !important;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.ngVAeKi9wKA4bNF7 {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
}

.ngVAeKi9wKA4bNF7 .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
}

.ngVAeKi9wKA4bNF7 .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.fNUoM3vltBsE37RJ {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
  margin-right: 0;
}

.fNUoM3vltBsE37RJ:hover {
  background-color: #185625;
}

.VAGiotW2xkL4BQrh {
  width: 100%;
  background-color: #dd0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.VAGiotW2xkL4BQrh:hover {
  background-color: #721010;
}

.v5e599Vj4WUNjj6p {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.v5e599Vj4WUNjj6p:hover {
  color: #305375;
}

.W0QLWCRPC_cZtbQk {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrVsQ1m6_QOoOTPq {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.wrVsQ1m6_QOoOTPq .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.wrVsQ1m6_QOoOTPq .vR20VsIEF4UYG_kZ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.wrVsQ1m6_QOoOTPq .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.wrVsQ1m6_QOoOTPq .p-dialog-content {
  background-color: #f3f5f7;
}

.qTgdZiPuC1kwAW_J {
  width: 674px !important;
  height: fit-content;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.qTgdZiPuC1kwAW_J .p-dialog {
  border-radius: 16px !important;
}

.qTgdZiPuC1kwAW_J .p-dialog-footer {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.qTgdZiPuC1kwAW_J .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.qTgdZiPuC1kwAW_J .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.qTgdZiPuC1kwAW_J .p-dialog-content {
  background-color: #f3f5f7;
}

.ol_vVenJaZUL8yJl {
  margin-bottom: 52px;
  width: 100%;
}

.ol_vVenJaZUL8yJl .p-dropdown-trigger {
  margin-right: 10px;
}

.ol_vVenJaZUL8yJl .p-dropdown {
  width: 100% !important;
  text-align: left;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
  border: none;
}

.ol_vVenJaZUL8yJl .p-dropdown-label {
  display: block;
  padding: 14px 20px;
  font-size: 18px;
  font-family: "Roboto";
}

.aIW59hLseTkBO5tB {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 20px;
}

.aIW59hLseTkBO5tB .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.aIW59hLseTkBO5tB .p-dropdown-items li {
  height: 40px;
  border-radius: 15px;
  margin: 4px 0;
  font-size: 18px;
  color: #303030;
}

.aIW59hLseTkBO5tB .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.aIW59hLseTkBO5tB
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.aIW59hLseTkBO5tB .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.aIW59hLseTkBO5tB .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.aIW59hLseTkBO5tB .p-dropdown-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.Q1LpnZIuZ98NAk9w {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.m2GBGjZCY8kIejJv {
  background: #ffffff;
  padding: 18px 16px 18px 12px;
  border-radius: 8px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sYIqrGB2EEfhNXAj {
  display: flex;
  gap: 18px;
}

.eZZINFaNnWAanJYH {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 1px;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  background-color: #4d87be;
  border-radius: 5px;
  min-height: 14px;
  height: 100%;
  width: 35px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.R2WSP3Xzy8phZ1Um {
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.XIIrnjkrwmEXpXTQ {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.rYrJvYtSMAQDGqLx {
  color: #888888;
  font-weight: 400;
  font-size: 12px;
  margin-left: 3px;
}

.sVLIRUSTKc4tQD8Q {
  display: flex;
  align-items: center;
}

.sVLIRUSTKc4tQD8Q button {
  cursor: pointer;
}

.a8CweMvFQthhEbcU {
  color: #1976d2;
  background: none;
  border: none;
  width: 36px;
  height: 36px;
}

.zUHewtBgZMfLOOyx {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 20px;
  width: 36px;
  height: 36px;
}

.a8CweMvFQthhEbcU i::before,
.zUHewtBgZMfLOOyx i::before {
  font-size: 20px;
}

.p4U8TKIo4oMDrfwL:hover {
  background-color: #e1e7ed;
}

.p4U8TKIo4oMDrfwL span::before {
  color: #4d87be !important;
  font-size: 20px;
}

@media screen and (max-width: 600px) {
  .Kq5YxlXICEqkJ9uq {
    gap: 0;
  }

  .D83hEwycbYxKx2Uo {
    padding: 0 !important;
  }

  .D83hEwycbYxKx2Uo span {
    display: none;
  }

  .D83hEwycbYxKx2Uo i {
    font-size: 12px;
    background-color: #f2e1bc;
    padding: 7px;
    margin-left: 8px;
    border-radius: 6px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media screen and (max-width: 510px) {
  .Kq5YxlXICEqkJ9uq {
    margin: 10px 0 14px 0;
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
  }

  .Kq5YxlXICEqkJ9uq h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .D83hEwycbYxKx2Uo {
    width: 100%;
    padding: 0;
  }

  .D83hEwycbYxKx2Uo i {
    margin-left: 0;
  }

  .wrVsQ1m6_QOoOTPq,
  .qTgdZiPuC1kwAW_J {
    width: 350px !important;
  }

  .qTgdZiPuC1kwAW_J .field label {
    font-size: 16px !important;
  }

  .wrVsQ1m6_QOoOTPq .p-dialog-title,
  .qTgdZiPuC1kwAW_J .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .wrVsQ1m6_QOoOTPq .vR20VsIEF4UYG_kZ {
    font-size: 16px;
  }

  .a2yrN1pM9CUr13gZ {
    font-size: 16px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
      0 2px 6px rgba(0, 0, 0, 0.12);
  }

  .GdWTwEzlr4Du68Uy {
    font-size: 16px;
  }

  .fNUoM3vltBsE37RJ {
    padding: 14px 0;
    font-size: 16px;
  }

  .VAGiotW2xkL4BQrh {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }

  .v5e599Vj4WUNjj6p {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .ol_vVenJaZUL8yJl .p-dropdown-label {
    font-size: 16px;
  }

  .lfZnwueCgY9f_roT {
    width: 100%;
    height: 44px;
    margin: 0;
    padding: 5px 10px;
    border-radius: 16px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
    background: #ffffff;
    grid-area: dropdown;
  }
}

.pjD008xo270cc1JX span::before {
  color: #4d87be !important;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/Organizations.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;iCAC+B;AACjC;;AAEA;EACE,uCAAuC;EACvC;iCAC+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB;iCAC+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB;iCAC+B;EAC/B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB;mCAC+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".pageWrapper {\r\n  max-width: 1310px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.header {\r\n  margin: 25px 0 30px 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.headerContentContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.createBtn i {\r\n  font-size: 16px;\r\n  background-color: #f2e1bc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n  background-color: #f2e1bc;\r\n  border: 1px solid #f3f5f7;\r\n  padding: 20px 24px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n  display: flex;\r\n  justify-content: start;\r\n  color: #303030;\r\n  font-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n  border: 1px solid #f3f5f7;\r\n  padding: 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n  text-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td > div) {\r\n  margin-left: 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr) .cellImageWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.imageCell {\r\n  background-size: cover;\r\n  height: 50px;\r\n  width: 71px;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.imageCell i {\r\n  display: none;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell i {\r\n  display: block;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell div {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #2e2e2e55;\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td:hover) .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.hoverableCell {\r\n  flex-shrink: 0;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td:hover) .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  padding-inline: 16px;\r\n  min-height: 69px;\r\n  font-size: 18px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.activeSoundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 22px;\r\n}\r\n\r\n.playBtn span::before {\r\n  color: #56be4d;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.soundBtn span::before,\r\n.exportBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.exportBtn:hover span::before {\r\n  color: #20336c !important;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn,\r\n.exportBtn {\r\n  width: 70px;\r\n  height: 67px;\r\n}\r\n\r\n.pageWrapper .playBtn:hover {\r\n  background-color: #c5f3c1;\r\n}\r\n\r\n.pageWrapper .soundBtn:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.pageWrapper .deleteBtn:hover {\r\n  background-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n  color: #56be4d;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.pageWrapper .playBtn span::before {\r\n  color: #185625;\r\n}\r\n\r\n.pageWrapper .soundBtn:hover span::before {\r\n  color: #20336c;\r\n}\r\n\r\n.playBtn:hover span::before {\r\n  color: #185625;\r\n}\r\n\r\n.soundBtn:hover span::before {\r\n  color: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n}\r\n\r\n.uploadBtn {\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 14px 0px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n  background-color: #20336c;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n  width: fit-content;\r\n  flex-grow: 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.preview {\r\n  background-color: #f2efea;\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.stationCard {\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 54px;\r\n  overflow: hidden;\r\n}\r\n\r\n.stationCard .image {\r\n  height: 173px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n  height: 77px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  background-color: #ffffff;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.phonePrefix {\r\n  border-radius: 16px 0 0 16px !important;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.inputPhone {\r\n  border-radius: 0 16px 16px 0 !important;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-right: 0;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #dd0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.organizationsActionsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.deleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.organizationModal {\r\n  width: 674px !important;\r\n  height: fit-content;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.dropDownWrapper {\r\n  margin-bottom: 52px;\r\n  width: 100%;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-trigger) {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100% !important;\r\n  text-align: left;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n  border: none;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 14px 20px;\r\n  font-size: 18px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 40px;\r\n  border-radius: 15px;\r\n  margin: 4px 0;\r\n  font-size: 18px;\r\n  color: #303030;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 18px 16px 18px 12px;\r\n  border-radius: 8px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.cardContent {\r\n  display: flex;\r\n  gap: 18px;\r\n}\r\n\r\n.cardBadge {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  padding: 1px;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  background-color: #4d87be;\r\n  border-radius: 5px;\r\n  min-height: 14px;\r\n  height: 100%;\r\n  width: 35px;\r\n  word-break: break-word;\r\n  overflow-wrap: break-word;\r\n  white-space: normal;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 26px;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.subfield {\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  margin-left: 3px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.actions button {\r\n  cursor: pointer;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 20px;\r\n}\r\n\r\n.exportBtn:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.exportBtn span::before {\r\n  color: #4d87be !important;\r\n  font-size: 20px;\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .header {\r\n    gap: 0;\r\n  }\r\n\r\n  .createBtn {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .createBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn i {\r\n    font-size: 12px;\r\n    background-color: #f2e1bc;\r\n    padding: 7px;\r\n    margin-left: 8px;\r\n    border-radius: 6px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 510px) {\r\n  .header {\r\n    margin: 10px 0 14px 0;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n  }\r\n\r\n  .header h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .createBtn {\r\n    width: 100%;\r\n    padding: 0;\r\n  }\r\n\r\n  .createBtn i {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .deleteModal,\r\n  .organizationModal {\r\n    width: 350px !important;\r\n  }\r\n\r\n  .organizationModal :global(.field) label {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  .deleteModal :global(.p-dialog-title),\r\n  .organizationModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n\r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .input {\r\n    font-size: 16px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n      0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .phonePrefix {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown-label) {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 100%;\r\n    height: 44px;\r\n    margin: 0;\r\n    padding: 5px 10px;\r\n    border-radius: 16px;\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n    background: #ffffff;\r\n    grid-area: dropdown;\r\n  }\r\n}\r\n\r\n.exportBtnMobile span::before {\r\n  color: #4d87be !important;\r\n  font-size: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `husEKthKYJAc_0Jy`;
export var header = `Kq5YxlXICEqkJ9uq`;
export var headerContentContainer = `m7caBGPY3vcHiQrw`;
export var createBtn = `D83hEwycbYxKx2Uo`;
export var cellImageWrapper = `jrHaAwhIsuyHXUpT`;
export var imageCell = `h7jj0RHK00zGd2f8`;
export var cellInsider = `Ehpap2ajkkUChVNB`;
export var hoverableCell = `qUKhoyUZBFUto1eO`;
export var cellSoundWrapper = `pvPx2wdLwJihRKwp`;
export var activeSoundBtn = `ppuMNdpCR9kgPbhS`;
export var playBtn = `pU12Ei58k8UIbHOx`;
export var deleteBtn = `UnbL6VAQMG85HNqO`;
export var soundBtn = `dwmsJzJNZKY7UbfL`;
export var exportBtn = `p4U8TKIo4oMDrfwL`;
export var activeBtn = `K2IrzQkh5MegWWVR`;
export var uploadBtn = `Mp5jVP1l42k1TjbK`;
export var cardWrapper = `pD5ouHisBTEs8Klr`;
export var preview = `cUy_s0zrNQ88HWUr`;
export var stationCard = `Tc5IpmuqkUKBNjjR`;
export var image = `yXv_pSMTUsY5eoZ7`;
export var titleWrapper = `oUsnoH13QfsFE4Ya`;
export var input = `a2yrN1pM9CUr13gZ`;
export var phonePrefix = `GdWTwEzlr4Du68Uy`;
export var inputPhone = `GdLxUVfCvgNLiSVL`;
export var selectButton = `ngVAeKi9wKA4bNF7`;
export var saveBtn = `fNUoM3vltBsE37RJ`;
export var deleteDialogBtn = `VAGiotW2xkL4BQrh`;
export var cancelDialogBtn = `v5e599Vj4WUNjj6p`;
export var organizationsActionsContainer = `W0QLWCRPC_cZtbQk`;
export var deleteModal = `wrVsQ1m6_QOoOTPq`;
export var text = `vR20VsIEF4UYG_kZ`;
export var organizationModal = `qTgdZiPuC1kwAW_J`;
export var dropDownWrapper = `ol_vVenJaZUL8yJl`;
export var dropDownPanel = `aIW59hLseTkBO5tB`;
export var cardList = `Q1LpnZIuZ98NAk9w`;
export var cardItem = `m2GBGjZCY8kIejJv`;
export var cardContent = `sYIqrGB2EEfhNXAj`;
export var cardBadge = `eZZINFaNnWAanJYH`;
export var cardInfo = `R2WSP3Xzy8phZ1Um`;
export var name = `XIIrnjkrwmEXpXTQ`;
export var subfield = `rYrJvYtSMAQDGqLx`;
export var actions = `sVLIRUSTKc4tQD8Q`;
export var cardEditBtn = `a8CweMvFQthhEbcU`;
export var cardDeleteBtn = `zUHewtBgZMfLOOyx`;
export var dropdown = `lfZnwueCgY9f_roT`;
export var exportBtnMobile = `pjD008xo270cc1JX`;
export default ___CSS_LOADER_EXPORT___;
